import { CollectionReference, deleteDoc, doc } from 'firebase/firestore'
import { useState } from 'react'
import { HelpItem } from '../types'

export const useDeleteHelpItem = (col: CollectionReference<HelpItem>) => {
  const [deletingId, setDeletingId] = useState<string>()

  const openDeleteDialog = (id: string) => {
    setDeletingId(id)
  }

  const closeDeleteDialog = () => {
    setDeletingId(undefined)
  }

  const confirmDelete = async () => {
    if (deletingId) {
      await deleteDoc(doc(col, deletingId))
      setDeletingId(undefined)
    }
  }

  return {
    deletingId,
    openDeleteDialog,
    closeDeleteDialog,
    confirmDelete,
  }
}
